import { initialState as initialApplicationState } from '@redux/modules/application/reducer';
import { initialState as initialAuthenticationState } from '@redux/modules/authentication/reducer';
import { initialState as initialFormState } from '@redux/modules/form/reducer';
import { initialState as initialSectionState } from '@redux/modules/section/reducer';
import { initialState as initialSaveState } from '@redux/modules/save/reducer';
import { initialState as initialAPIState } from '@redux/modules/api/reducer';
import { initialState as initialFeatureFlagsState } from '@redux/modules/featureFlags/reducer';
import { initialState as initialSettingsState } from '@redux/modules/settings/reducer';

// We want to use the defaultReduxState (instead of trying to mock it up).
// Whatever the defaultReduxState is in will determine how much we need to
// support within the dependencies. The defaultReduxState will determine how
// much conditional statements we'll need to support. The more it is defined,
// the less. The less it is defined, the more conditional statements. If a
// reducer/action makes the state less than the defaultReduxState, that can be a
// concern. Using this defaultReduxState for testing makes it easier for
// refactoring as well.

/** @type {import("types/state").RootState} */
export const defaultReduxState = {
  application: initialApplicationState,
  api: initialAPIState,
  authentication: initialAuthenticationState,
  form: initialFormState,
  section: initialSectionState,
  save: initialSaveState,
  featureFlags: initialFeatureFlagsState,
  settings: initialSettingsState,
};
